<div class="top-box">
  <div class="row">
      <h1> {{header}}</h1>
  </div>
</div>